import Vue from "vue";

import sl from "./sl";
import VuePageTransition from "vue-page-transition";
import VueFormulate from '@braid/vue-formulate';

import { ca, de, en, fr, it, nb, pl, pt, es, sk, sv  } from '@braid/vue-formulate-i18n'
import VueFormulateDate from '@/components/form/elements/vue-formulate-date';
import { InlineSvgPlugin } from 'vue-inline-svg';

Vue.use(InlineSvgPlugin);
Vue.use(VuePageTransition);
Vue.use(VueFormulate, {
    plugins: [ en, es, ca, it, fr, pt, de, sv, nb, pl, sk ],
    library: {
      datewithplaceholder: {
        classification: 'text',
        component: VueFormulateDate
      }
    }
  }
)

VueFormulate.extend({
  locales: {
    ['sl']: sl
  }
})
